module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ed.45555274.png";